import type { AutomationsTranslation } from './types';

export const automationsAr: AutomationsTranslation = {
  nav: 'الأتمتة',
  title: 'الأتمتة',
  description:
    'قواعد تعمل وحدها: رسائل على موقعك، وردود ووسوم وتذاكر في المحادثات. لا تعمل القاعدة إلا بعد نشرها وتشغيلها.',
  loading: 'جارٍ تحميل قواعد الأتمتة',
  brand: 'العلامة التجارية',
  open: 'الأتمتة',
  openLabel: 'الأتمتة لـ {{name}}',
  guide: 'كيف تعمل الأتمتة',
  noPermission: 'لا يسمح دورك بتغيير قواعد الأتمتة. اطلب ذلك من مالك مساحة العمل أو مديرها.',
  forbidden: {
    title: 'لا يمكنك رؤية قواعد الأتمتة',
    description: 'اطلب من مالك مساحة العمل أو مديرها دورًا يسمح بعرض قواعد الأتمتة.',
  },
  noBrands: {
    title: 'لا توجد علامة تجارية بعد',
    description: 'أضف علامة تجارية وموقعها أولًا، ثم أعدّ قواعد الأتمتة الخاصة بها هنا.',
    action: 'انتقل إلى العلامات التجارية والتثبيت',
  },
  new: 'قاعدة أتمتة جديدة',
  sections: {
    visitor: {
      title: 'على موقعك',
      description: 'رسائل بجانب زر المحادثة تدعو الزوار إلى السؤال. تعمل في متصفحات الزوار.',
    },
    conversation: {
      title: 'في المحادثات',
      description: 'ردود وملاحظات ووسوم وأولويات وفرق وتذاكر أثناء المحادثة.',
    },
    empty: 'لا شيء بعد.',
  },
  status: {
    off: 'متوقفة',
    draft: 'مسودة فقط',
    changes: 'منشورة بالإصدار {{version}} · تغييرات غير منشورة',
    published: 'منشورة بالإصدار {{version}}',
  },
  list: {
    edit: 'تعديل',
    editLabel: 'تعديل {{name}}',
    duplicate: 'نسخ',
    duplicateLabel: 'نسخ {{name}}',
    delete: 'حذف',
    deleteLabel: 'حذف {{name}}',
    switchLabel: 'تشغيل {{name}}',
    inBrowser: 'تعمل في متصفحات الزوار',
    neverRan: 'لم تعمل بعد',
    ranOnce: 'عملت مرة واحدة هذا الأسبوع',
    ranTimes: 'عملت {{n}} مرة هذا الأسبوع',
    ranLast: '{{ran}} · آخر مرة {{when}}',
    copyName: '{{name}} (نسخة)',
    duplicated: 'أُنشئت {{name}} كمسودة.',
    turnedOn: '{{name}} تعمل الآن.',
    turnedOff: '{{name}} متوقفة الآن.',
    deleted: 'حُذفت {{name}}.',
    deleteTitle: 'حذف {{name}}؟',
    deleteBody:
      'تُحذف معها إصداراتها وسجلّ ما فعلته. لا يمكن التراجع عن ذلك. لإيقافها مؤقتًا، أوقف تشغيلها بدلًا من حذفها.',
    deleteConfirm: 'حذف القاعدة',
  },
  gallery: {
    title: 'ابدأ من قالب',
    description: 'اختر قاعدة تبدأ منها. تُحفظ كمسودة، فيمكنك مراجعتها قبل أن تعمل.',
    ready: 'قواعد جاهزة',
    scratch: 'ابدأ من الصفر',
    scratchDescription: 'قاعدة فارغة تكتبها بنفسك.',
    website: 'على موقعك',
    chat: 'في المحادثات',
    use: 'استخدام',
    useLabel: 'استخدام القالب {{name}}',
    created: 'أُنشئت {{name}} كمسودة.',
    chooseTag: 'أنت تختار الوسم.',
  },
  templates: {
    welcome: {
      name: 'رد ترحيبي',
      description: 'عندما تبدأ محادثة وتنتظر شخصًا، أخبر العميل أن أحدًا سيرد قريبًا.',
    },
    rescue: {
      name: 'إنقاذ المحادثة',
      description: 'بعد 90 ثانية دون رد، اعتذر واطلب بريدًا إلكترونيًا وارفع الأولوية.',
    },
    returning: {
      name: 'رسالة للزائر العائد',
      description: 'في الزيارة الثالثة أو بعدها، اعرض المساعدة بعد 5 ثوانٍ.',
    },
    pricing: {
      name: 'مساعدة في صفحة الأسعار',
      description: 'بعد 30 ثانية في صفحة الأسعار، اعرض الإجابة عن الأسئلة.',
    },
    outOfHours: {
      name: 'رد خارج ساعات العمل',
      description: 'خارج ساعات العمل، أخبر العميل متى سترد واجعل المحادثة تذكرة.',
    },
    tagByPage: {
      name: 'وسم حسب الصفحة',
      description: 'ضع وسمًا على المحادثات التي تبدأ في صفحة الدفع.',
    },
    scratchWebsite: {
      name: 'رسالة موقع جديدة',
      description: 'رسالة على موقعك.',
    },
    scratchChat: {
      name: 'قاعدة محادثات جديدة',
      description: 'قاعدة تعمل في المحادثات.',
    },
  },
  limits: {
    title: 'حدود الرسائل',
    description:
      'مهما كان عدد قواعد الموقع لديك، لا يرى الزائر الواحد أكثر من هذا العدد من الرسائل.',
    maxPerDay: 'عدد الرسائل التي يراها الزائر في اليوم',
    maxPerDayHint: 'من 1 إلى 3.',
    dismissHours: 'بعد أن يغلق الزائر رسالة، انتظر (بالساعات)',
    dismissHoursHint: 'من 1 إلى 168 (أسبوع).',
    invalid: 'أدخل عددًا صحيحًا من {{min}} إلى {{max}}.',
    save: 'حفظ الحدود',
    saved: 'حُفظت حدود الرسائل لـ {{name}}.',
  },
  editor: {
    loading: 'جارٍ تحميل القاعدة',
    back: 'كل قواعد الأتمتة',
    kinds: { visitor: 'قاعدة أتمتة للموقع', conversation: 'قاعدة أتمتة للمحادثات' },
    name: 'الاسم',
    nameHint: 'لفريقك. لا يراه العملاء أبدًا.',
    whenStep: {
      title: 'عندما',
      description: 'ما الذي يبدأ القاعدة.',
      event: 'الحدث',
      seconds: {
        page_view: 'الثواني على الصفحة',
        customer_waiting: 'الثواني دون رد',
      },
      secondsHint: 'من {{min}} إلى {{max}}.',
      kindNote:
        'تبقى قاعدة الموقع على الموقع، وقاعدة المحادثات في المحادثات. لإنشاء النوع الآخر، ابدأ قاعدة جديدة.',
    },
    ifStep: {
      title: 'إذا',
      description: 'ما يجب أن يكون صحيحًا. اتركه فارغًا لتعمل القاعدة كل مرة.',
      match: 'تعمل عندما',
      all: 'تصح كلها',
      any: 'يصح أيٌّ منها',
      condition: 'الشرط {{number}}',
      field: 'المعلومة',
      op: 'المقارنة',
      value: 'القيمة',
      yes: 'نعم',
      no: 'لا',
      empty: 'لا شروط: تعمل القاعدة في كل مرة يقع فيها الحدث.',
      count: '{{n}} من {{max}}',
      add: 'إضافة شرط',
      added: 'أُضيف الشرط {{number}}.',
      remove: 'إزالة الشرط {{number}}',
      removeShort: 'إزالة',
      removed: 'أُزيل الشرط {{number}}.',
      full: 'للقاعدة {{max}} شروط على الأكثر.',
      addValue: 'إضافة',
      addValueLabel: 'إضافة إلى الشرط {{number}}',
      removeValue: 'إزالة {{value}}',
      countryHint: 'رموز البلدان من حرفين، مثل PK أو AE. اضغط Enter بعد كل رمز.',
      languageHint: 'رموز اللغات، مثل ar أو en. اضغط Enter بعد كل رمز.',
      tagHint: 'تعذّر تحميل وسوم العلامة التجارية. اكتب وسمًا واضغط Enter.',
      noTags: 'ليس لهذه العلامة التجارية وسوم بعد. أضفها في الردود المحفوظة والوسوم.',
      noTeams: 'ليس لهذه العلامة التجارية فرق دعم بعد.',
    },
    thenStep: {
      title: 'فعندئذٍ',
      description: 'ما تفعله القاعدة، بهذا الترتيب.',
      action: 'الإجراء {{number}}',
      type: 'افعل هذا',
      count: '{{n}} من {{max}}',
      add: 'إضافة إجراء',
      added: 'أُضيف الإجراء {{number}}.',
      remove: 'إزالة الإجراء {{number}}',
      removeShort: 'إزالة',
      removed: 'أُزيل الإجراء {{number}}.',
      full: 'للقاعدة {{max}} إجراءات على الأكثر.',
      prompt: 'نص الرسالة على الموقع',
      message: 'الرسالة',
      messageHint: 'الإنجليزية مطلوبة. تُعرض الإنجليزية في أي لغة تُترك فارغة. حتى {{max}} حرف.',
      note: 'ملاحظة للفريق',
      tag: 'الوسم',
      tagPlaceholder: 'اختر وسمًا',
      tagUnknown: '«{{tag}}» ليس من وسوم هذه العلامة التجارية. اختر واحدًا قبل النشر.',
      tagFree: 'اسم الوسم',
      tagFreeHint: 'تعذّر تحميل وسوم العلامة التجارية. اكتب الوسم كما هو تمامًا.',
      team: 'الفريق',
      teamPlaceholder: 'اختر فريقًا',
      priority: 'الأولوية',
    },
    fields: {
      page_url: 'عنوان الصفحة',
      referrer: 'جاء من (المُحيل)',
      visit_count: 'عدد الزيارات حتى الآن',
      country: 'البلد',
      device: 'الجهاز',
      language: 'اللغة',
      signed_in: 'العميل مسجّل الدخول',
      hours_open: 'ضمن ساعات العمل',
      anyone_online: 'أحد أعضاء الفريق متصل',
      owner: 'من يتولى المحادثة',
      tag: 'الوسم',
      team: 'الفريق',
    },
    ops: {
      contains: 'يحتوي على',
      starts_with: 'يبدأ بـ',
      is: 'هو',
      not_contains: 'لا يحتوي على',
      at_least: 'لا يقل عن',
      at_most: 'لا يزيد على',
      is_not: 'ليس',
    },
    events: {
      page_view: 'زائر على صفحة',
      chat_started: 'بدء محادثة',
      customer_waiting: 'عميل ينتظر ردًا',
      chat_closed: 'إغلاق محادثة',
      offline_message: 'ترك رسالة حين لا يمكن لأحد الرد',
    },
    actions: {
      show_prompt: 'عرض رسالة على الموقع',
      send_message: 'إرسال رسالة',
      add_note: 'إضافة ملاحظة خاصة',
      add_tag: 'إضافة وسم',
      set_priority: 'تحديد الأولوية',
      assign_team: 'إرسال إلى فريق',
      make_ticket: 'إنشاء تذكرة',
    },
    warnings: {
      title: 'يمكن حفظ هذه القاعدة، لكن لا يمكن نشرها كما هي:',
      field_not_allowed: 'هذه المعلومة غير معروفة لهذا النوع من القواعد. اختر غيرها.',
      action_not_allowed: 'هذا الإجراء غير متاح لهذا النوع من القواعد.',
      action_repeated: 'هذا الإجراء موجود في القاعدة بالفعل. تنفّذه القاعدة مرة واحدة فقط.',
      prompt_required: 'قاعدة الموقع تعرض رسالة. أضف الإجراء «عرض رسالة على الموقع».',
      message_needs_people:
        'الذكاء الاصطناعي يرد في هذه المحادثة. رسالة من هذه القاعدة ستقاطعه — أضف ‹من يتولى المحادثة ليس الذكاء الاصطناعي›.',
      message_after_close: 'لا يمكن إرسال رسالة بعد إغلاق المحادثة.',
    },
    problems: {
      name: 'أعطِ القاعدة اسمًا.',
      seconds: 'أدخل عددًا صحيحًا من الثواني من {{min}} إلى {{max}}.',
      conditionValue: 'الشرط {{number}}: اختر قيمة أو اكتبها.',
      conditionNumber: 'الشرط {{number}}: أدخل عددًا صحيحًا من {{min}} إلى {{max}}.',
      conditionLong: 'الشرط {{number}}: استخدم {{max}} حرفًا على الأكثر.',
      messageEnglish: 'الإجراء {{number}}: اكتب النص بالإنجليزية.',
      messageLong: 'الإجراء {{number}}: استخدم {{max}} حرفًا على الأكثر في كل لغة.',
      note: 'الإجراء {{number}}: اكتب الملاحظة.',
      tag: 'الإجراء {{number}}: اختر وسمًا.',
      team: 'الإجراء {{number}}: اختر فريقًا.',
      noActions: 'أضف إجراءً واحدًا على الأقل.',
    },
    save: 'حفظ المسودة',
    publish: 'نشر',
    saved: 'حُفظت مسودة {{name}}.',
    published: 'نُشرت {{name}} بالإصدار {{version}}.',
    unsaved: 'لديك تغييرات غير محفوظة.',
    reset: 'التراجع عن التغييرات',
    enabled: 'تعمل',
    enabledHint: 'الإيقاف يُبقي القاعدة لكنها لا تعمل أبدًا.',
    turnedOn: '{{name}} تعمل الآن.',
    turnedOff: '{{name}} متوقفة الآن.',
    statusLine: {
      published: 'الإصدار {{version}}، نشره {{who}}، {{when}}.',
      publishedBySystem: 'الإصدار {{version}}، نُشر {{when}} عند نقل رسائلك إلى هنا.',
      draft: 'لم تُنشر بعد، لذا لا تعمل.',
      changes: 'في المسودة تغييرات لم تُنشر بعد.',
      off: 'متوقفة، لذا لا تعمل.',
    },
    conflict: 'غيّر شخص آخر هذه القاعدة بعد أن فتحتها. أعد التحميل لترى نسخته؛ ستضيع تغييراتك هنا.',
    reload: 'إعادة التحميل',
    reloaded: 'حُمّل أحدث إصدار.',
    versions: {
      title: 'الإصدارات',
      description: 'يُحفظ كل نشر. الاستعادة تنسخ إصدارًا إلى المسودة؛ انشرها لتعمل من جديد.',
      empty: 'لم تُنشر بعد.',
      version: 'الإصدار {{version}}',
      by: 'نشره {{who}}، {{when}}',
      bySystem: 'نشره Hamnivo {{when}}',
      current: 'يعمل الآن',
      restore: 'استعادة',
      restoreLabel: 'استعادة الإصدار {{version}}',
      restoreTitle: 'استعادة الإصدار {{version}}؟',
      restoreBody: 'يحلّ الإصدار {{version}} محل المسودة. لا يتغير ما يعمل إلا عند النشر.',
      restoreConfirm: 'استعادة إلى المسودة',
      restored: 'نُسخ الإصدار {{version}} إلى المسودة.',
      saveFirst: 'احفظ تغييراتك أو تراجع عنها أولًا.',
    },
    runs: {
      title: 'آخر مرات التشغيل',
      description: 'ما فعلته هذه القاعدة في المحادثات، الأحدث أولًا.',
      empty: 'لم تعمل بعد.',
      when: 'متى',
      chat: 'المحادثة',
      actions: 'الإجراءات',
      result: 'النتيجة',
      open: 'فتح المحادثة',
      noChat: 'لا محادثة',
      version: 'الإصدار {{version}}',
      outcomes: { done: 'تمّ', skipped: 'تُخطّي', failed: 'فشل' },
      reasons: {
        ai_has_chat: 'لم تُرسل الرسالة: كان الذكاء الاصطناعي يتولى المحادثة.',
        message_limit: 'لم تُرسل الرسالة: بلغت الرسائل الآلية حدها اليومي.',
        no_bot: 'لم تُرسل الرسالة: لا يوجد روبوت في المحادثة لإرسالها.',
        window_closed:
          'لم تُرسل الرسالة: لا يسمح واتساب إلا برسائل القوالب بعد مرور 24 ساعة على آخر رسالة من العميل.',
      },
      noActions: 'لا شيء',
    },
    try: {
      title: 'جرّبها',
      description:
        'صف زائرًا أو محادثة وانظر ماذا ستفعل هذه القاعدة. إنه الفحص نفسه الذي تجريه القاعدة الحقيقية.',
      sample: 'مثال',
      unknown: 'غير معروف',
      yes: 'نعم',
      no: 'لا',
      tagsHint: 'افصل بين الوسوم بفواصل.',
      countryHint: 'رمز من حرفين، مثل PK.',
      would: 'ستعمل هذه القاعدة.',
      wouldNot: 'لن تعمل هذه القاعدة.',
      verdicts: {
        true: 'صحيح',
        false: 'غير صحيح',
        null: 'غير معروف، فيُعدّ غير صحيح',
      },
      noConditions: 'لا شروط: تعمل في كل مرة يقع فيها الحدث.',
      preview: 'ما يراه العميل',
      previewIn: 'بـ{{language}}، لغة الزائر.',
      noWords: 'هذه القاعدة لا تقول شيئًا للعميل.',
    },
  },
  devices: { desktop: 'حاسوب', mobile: 'هاتف', tablet: 'جهاز لوحي' },
  owners: {
    ai: 'الذكاء الاصطناعي',
    waiting: 'لا أحد بعد (بانتظار شخص)',
    person: 'شخص من الفريق',
  },
  priorities: { urgent: 'عاجلة', high: 'عالية', medium: 'متوسطة', low: 'منخفضة' },
  summary: {
    sentence: '{{event}}، إذا {{conditions}} ← {{actions}}',
    always: '{{event}} ← {{actions}}',
    aTeam: 'فريق',
    owners: { ai: 'الذكاء الاصطناعي', waiting: 'لا أحد بعد', person: 'أحد أعضاء الفريق' },
    devices: { desktop: 'حاسوبًا', mobile: 'هاتفًا', tablet: 'جهازًا لوحيًا' },
    priorities: { urgent: 'عاجلةً', high: 'عاليةً', medium: 'متوسطةً', low: 'منخفضةً' },
    events: {
      page_open: 'عندما يفتح زائر صفحة',
      page_view: 'عندما يبقى زائر على صفحة مدة {{duration}}',
      chat_started: 'عندما تبدأ محادثة',
      customer_waiting: 'عندما ينتظر عميل ردًا مدة {{duration}}',
      chat_closed: 'عندما تُغلق محادثة',
      offline_message: 'عندما تُترك رسالة حين لا يمكن لأحد الرد',
    },
    fields: {
      page_url: 'عنوان الصفحة',
      referrer: 'المُحيل',
      visit_count: 'عدد الزيارات',
      country: 'البلد',
      device: 'الجهاز',
      language: 'اللغة',
      signed_in: 'تسجيل الدخول',
      hours_open: 'ساعات العمل',
      anyone_online: 'وجود أحد متصل',
      owner: 'من يتولى المحادثة',
      tag: 'الوسم',
      team: 'الفريق',
    },
    ops: {
      contains: '{{field}} يحتوي على {{value}}',
      starts_with: '{{field}} يبدأ بـ {{value}}',
      is: '{{field}} هو {{value}}',
      not_contains: '{{field}} لا يحتوي على {{value}}',
      at_least: '{{field}} لا يقل عن {{value}}',
      at_most: '{{field}} لا يزيد على {{value}}',
      is_not: '{{field}} ليس {{value}}',
    },
    flags: {
      hours_open: { yes: 'الوقت ضمن ساعات العمل', no: 'الوقت خارج ساعات العمل' },
      anyone_online: { yes: 'أحد أعضاء الفريق متصل', no: 'لا أحد من الفريق متصل' },
      signed_in: { yes: 'العميل مسجّل الدخول', no: 'العميل غير مسجّل الدخول' },
    },
    actions: {
      show_prompt: 'اعرض رسالة',
      send_message: 'أرسل رسالة',
      add_note: 'أضف ملاحظة خاصة',
      add_tag: 'أضف الوسم {{tag}}',
      set_priority: 'اجعل الأولوية {{priority}}',
      assign_team: 'أرسلها إلى {{team}}',
      make_ticket: 'أنشئ تذكرة',
    },
  },
};
